const Image = ({src}) => (
    <img src={src} className="section__image"/>
)

export {Image}